import React from 'react'
import { Slice } from 'gatsby'

const ShopPanel = ({ data, isBlackFriday }) => {
  return (
    <Slice
        panelData={data}
        isBlackFriday={isBlackFriday}
        alias={`shop_panel`}
    />
  )
}

export default ShopPanel
